export const AllowlistIocn = () => (
  <svg
    width={46}
    height={46}
    viewBox="0 0 46 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_599_17637)">
      <path
        d="M37.6707 27.19C37.6707 35.24 31.1407 41.78 23.0907 41.78C15.5707 41.78 9.39074 36.1 8.59074 28.8C8.58074 28.76 8.57074 28.72 8.57074 28.68C7.84074 24.15 8.90074 16.84 9.71074 12.39C10.0807 10.41 12.2407 9.34998 14.0307 10.28C14.5707 10.57 15.1407 10.87 15.7507 11.2C16.9507 9.36998 18.1607 7.66998 19.2307 6.18998C21.1307 3.56998 25.0407 3.56998 26.9307 6.18998C31.2607 12.13 37.6607 21.84 37.6607 27.19H37.6707Z"
        fill="url(#paint0_linear_599_17637)"
      />
      <path
        d="M33.5409 26.94C33.5409 32.76 28.8209 37.4799 23.0009 37.4799C17.1809 37.4799 12.4609 32.76 12.4609 26.94C12.4609 23.75 15.6309 18.4 18.4909 14.21C20.6609 11.03 25.3509 11.03 27.5209 14.21C30.3809 18.4 33.5509 23.75 33.5509 26.94H33.5409Z"
        fill="url(#paint1_linear_599_17637)"
      />
      <path
        opacity={0.62}
        d="M23.0004 31.7599C21.9204 31.7599 21.0404 30.8799 21.0404 29.7999V28.3699H19.6104C18.5304 28.3699 17.6504 27.4899 17.6504 26.4099C17.6504 25.3299 18.5304 24.4499 19.6104 24.4499H21.0404V23.0199C21.0404 21.9399 21.9204 21.0599 23.0004 21.0599C24.0804 21.0599 24.9604 21.9399 24.9604 23.0199V24.4499H26.3904C27.4704 24.4499 28.3504 25.3299 28.3504 26.4099C28.3504 27.4899 27.4704 28.3699 26.3904 28.3699H24.9604V29.7999C24.9604 30.8799 24.0804 31.7599 23.0004 31.7599Z"
        fill="url(#paint2_linear_599_17637)"
      />
      <path
        d="M26.3806 25.47H23.9506V23.04C23.9506 22.51 23.5206 22.08 22.9906 22.08C22.4606 22.08 22.0306 22.51 22.0306 23.04V25.47H19.6006C19.0706 25.47 18.6406 25.9 18.6406 26.43C18.6406 26.96 19.0706 27.39 19.6006 27.39H22.0306V29.82C22.0306 30.35 22.4606 30.78 22.9906 30.78C23.5206 30.78 23.9506 30.35 23.9506 29.82V27.39H26.3806C26.9106 27.39 27.3406 26.96 27.3406 26.43C27.3406 25.9 26.9106 25.47 26.3806 25.47Z"
        fill="white"
      />
      <path
        d="M14.7893 12.19H14.7793C14.7793 12.19 14.8293 12.13 14.7893 12.19Z"
        fill="url(#paint3_linear_599_17637)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_599_17637"
        x1={16.5007}
        y1={43.68}
        x2={27.8407}
        y2={7.71998}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00FF00" />
        <stop offset={0.52} stopColor="#00FF00" stopOpacity={0.89} />
        <stop offset={1} stopColor="#99FF00" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_599_17637"
        x1={21.3309}
        y1={40.46}
        x2={21}
        y2={14}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#017F01" />
        <stop offset={1} stopColor="#01A401" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_599_17637"
        x1={17.6604}
        y1={26.4199}
        x2={28.3404}
        y2={26.4199}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D1FD00" stopOpacity={0.8} />
        <stop offset={1} stopColor="#DEFD92" stopOpacity={0.5} />
      </linearGradient>
      <linearGradient
        id="paint3_linear_599_17637"
        x1={14.7993}
        y1={12.16}
        x2={14.7793}
        y2={12.19}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00FF00" />
        <stop offset={0.52} stopColor="#00FF00" stopOpacity={0.89} />
        <stop offset={1} stopColor="#99FF00" />
      </linearGradient>
      <clipPath id="clip0_599_17637">
        <rect width={46} height={46} fill="white" />
      </clipPath>
    </defs>
  </svg>
)
